import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { PATHS } from '../router/paths';
import { TokenExtension } from '@utils/extensions/token.extension.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { useQueryClient } from 'react-query';

export default function LoginMicrosoft() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [error, setError] = useState<string | null>();
  const [errorDescription, setErrorDescription] = useState<string | null>();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token');
      const urlError = urlParams.get('error');
      const urlErrorDescription = urlParams.get('error_description');

      if (urlError) {
        setError(urlError);
        setErrorDescription(urlErrorDescription);
        return;
      }

      if (token && token.length > 0) {
        TokenExtension.set(token);
        await queryClient.invalidateQueries(QueryKeys.login());
        navigate(PATHS().HOME);
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-app">
      {error ? (
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600">{t('error')}</h1>
          <p className="mt-4 text-lg text-gray-800 dark:text-zinc-200">
            {errorDescription}
          </p>
        </div>
      ) : (
        <div className="text-center">
          <svg
            className="animate-spin h-8 w-8 text-gray-600 dark:text-zinc-400 mx-auto"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            ></circle>
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291l1.414-1.414A6 6 0 0118 12h4c0 5.177-3.134 9.72-7.75 11.292l-1.5-1.5z"
            ></path>
          </svg>
          <p className="mt-4 text-lg text-gray-800 dark:text-zinc-200">
            {t('loading')}...
          </p>
        </div>
      )}
    </div>
  );
}
